import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, m } from "framer-motion";
import { X } from "lucide-react";

const CONSENT_KEY = "gooinvest-cookie-consent";
const CONSENT_DATE_KEY = "gooinvest-cookie-consent-date";
const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const decision = localStorage.getItem(CONSENT_KEY);
      const dateStr = localStorage.getItem(CONSENT_DATE_KEY);
      const date = dateStr ? parseInt(dateStr, 10) : 0;
      const fresh = date && Date.now() - date < ONE_YEAR_MS;
      if ((decision === "accepted" || decision === "rejected") && fresh) {
        return;
      }
    } catch {
      // localStorage indisponível, mostra mesmo assim
    }
    const t = window.setTimeout(() => setVisible(true), 800);
    return () => window.clearTimeout(t);
  }, []);

  const persist = (value: "accepted" | "rejected") => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
      localStorage.setItem(CONSENT_DATE_KEY, Date.now().toString());
    } catch {
      // ignore
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed z-50 bottom-0 left-0 right-0 sm:bottom-6 sm:right-6 sm:left-auto sm:max-w-md"
          role="dialog"
          aria-live="polite"
          aria-label="Aviso de cookies"
        >
          <div
            className="relative bg-card border border-border rounded-t-2xl rounded-b-none sm:rounded-2xl shadow-2xl p-6 font-sans"
            style={{ paddingBottom: "max(1.5rem, env(safe-area-inset-bottom))" }}
          >
            <button
              type="button"
              onClick={() => setVisible(false)}
              aria-label="Fechar aviso"
              className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors"
            >
              <X size={16} aria-hidden="true" />
            </button>

            <p className="text-sm text-muted-foreground leading-relaxed pr-6">
              Usamos cookies pra melhorar sua experiência no GooInvest. Você pode aceitar, rejeitar os não essenciais, ou ler nossa{" "}
              <Link
                to="/politica-de-privacidade"
                className="text-[hsl(var(--primary))] underline underline-offset-2 hover:text-[hsl(var(--primary))]/80"
              >
                Política de Privacidade
              </Link>
              .
            </p>

            <div className="mt-4 flex gap-3">
              <button
                type="button"
                onClick={() => persist("accepted")}
                className="flex-1 sm:flex-none bg-[hsl(var(--primary))] text-primary-foreground font-bold text-sm px-5 py-2.5 rounded-full hover:shadow-md transition"
              >
                Aceitar
              </button>
              <button
                type="button"
                onClick={() => persist("rejected")}
                className="flex-1 sm:flex-none bg-transparent border border-border text-foreground font-medium text-sm px-5 py-2.5 rounded-full hover:bg-muted/50 transition"
              >
                Rejeitar
              </button>
            </div>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
